/* eslint react/prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  compose,
  setDisplayName,
  setPropTypes,
  withProps,
} from 'recompose';
import { v4 as uuid } from 'uuid';
import PaymentWizardPage from './PaymentWizardPage';
import SignInUp from './SignInUp';
import PersonalDetails from './PersonalDetails';
import PaymentDetails from './PaymentDetails';

const STEPS = [
  {
    id: uuid(),
    title: 'Sign Up / Sign In',
    component: SignInUp,
  },
  {
    id: uuid(),
    title: 'Personal Details',
    component: PersonalDetails,
  },
  {
    id: uuid(),
    title: 'Payment Details',
    component: PaymentDetails,
  },
];

export const PaymentWizard = ({ step, options }) => (
  <PaymentWizardPage
    step={step}
    options={options}
    steps={STEPS}
  />
);

export default compose(
  setDisplayName('PaymentWizard'),
  withRouter,
  connect(({ paymentWizard: { step, options } }) => ({ step, options })),
  withProps(({ step }) => ({ title: STEPS[step].title })),
  setPropTypes({
    step: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  }),
)(PaymentWizard);
